<div class="container-fluid animated fadeIn">
	<div class="page-header-wrapper">
		<div class="page-header">
			<div class="page-header-left">
				<h2>
					{{ 'search-companies.pageTitle' | translate }}
				</h2>
			</div>
		</div>
	</div>

	<!-- CONTENT -->
	<eif-custom-tabs
		[tabs]="tabs"
		[activeTabId]="activeTabId"
		[actions]="tabActions"
		(tabChange)="onTabSelect($event)"
		[class]="'mt-4'">
		<div class="ds-tab-panel">
			@switch (activeTabId) {
				@case ('myCompanies') {
					<app-search-companies
						class="animated delay-500ms fadeIn"
						[companyUniverseSearch]="myCompanyUniverseSearch">
					</app-search-companies>
				}
				@case ('myConnections') {
					<app-search-companies
						class="animated delay-500ms fadeIn"
						[companyUniverseSearch]="myConnectionsUniverseSearch">
					</app-search-companies>
				}
				@case ('myNetwork') {
					<app-search-companies
						class="animated delay-500ms fadeIn"
						[companyUniverseSearch]="networkUniverseSearch">
					</app-search-companies>
				}
			}
		</div>
	</eif-custom-tabs>
</div>
